module.exports = __webpack_public_path__ + "static/media/warn.d0bd8ce6.ogg";